import React, {Component} from 'react';
import lang from '../../constants/Languages.js';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

class BackButton extends Component {
    goBack = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        const {clang, showBackButton} = this.props;

        return (
            <div className="back-button__container">
                {showBackButton &&
                    <button onClick={() => this.goBack()} className="back-button">
                        <span className="back-button__img"></span>
                        {lang[clang].back}
                    </button>}
            </div>
        );
    };
};

BackButton.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(BackButton);



// WEBPACK FOOTER //
// ./src/components/items/BackButton.js